<template>
	<el-dialog :visible="dialogVisible" @close="handleCloseDialog" width="80%" :close-on-click-modal="false"
		:close-on-press-escape="false" append-to-body>
		<!-- 标题 -->
		<template #title>
			<div class="quote-order-dialog-title">{{$t("message.costatus.diatitle")}}</div>
		</template>
		<div class="quote-order-detail">
			<el-row>
				<el-col :span="12">
					<span class="quote-order-detail-title">{{$t("message.cqorder.orderNumber")}}</span>
					{{quote_order_detail.quote_sn}}
				</el-col>
				<el-col :span="12">
					<span class="quote-order-detail-title">{{$t("message.cqorder.orderStatus")}}</span>
					<!-- 已通过审批 -->
					<template v-if="quote_order_detail.complete_status==0||quote_order_detail.complete_status==10">
						<span>
							{{quote_order_detail.quote_status==0? $t("message.cqorder.status1"): $t("message.cqorder.status2")}}
						</span>
					</template>
					<!-- 未通过 -->
					<template v-else>
						<span>
							{{quote_order_detail.complete_status==5? $t("message.cqorder.status3"): $t("message.cqorder.status4")}}
						</span>
					</template>
				</el-col>
			</el-row>
			<el-row style="margin-top:10px" v-if="quote_examine">
				<el-col>
					<span class="quote-order-detail-title">{{$t("message.costatus.info3")}}</span>
					<el-select v-model="select_status" size="mini">
						<el-option v-for="(item, index) in examine_options" :key="index" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<el-button @click="handleExamine(quote_order_detail.quote_id)" type="primary" size="mini"
						style="margin-left: 10px">
						{{$t("public.submitBtn")}}
					</el-button>
				</el-col>
			</el-row>
			<el-row style="margin-top:10px">
				<el-col :span="12" v-if="quote_order_detail.postscript">
					<span class="quote-order-detail-title">客戶備註</span>
					{{quote_order_detail.postscript}}
				</el-col>
				<el-col :span="12" v-else>
					<span class="quote-order-detail-title">客戶備註</span>
					暫無
				</el-col>
				<el-col :span="12" v-if="quote_order_detail.to_buyer">
					<span class="quote-order-detail-title">商家備註</span>
					{{quote_order_detail.to_buyer}}
				</el-col>
				<el-col :span="12" v-else>
					<span class="quote-order-detail-title">商家備註</span>
					暫無
				</el-col>
			</el-row>

		</div>
		<!-- 表格 -->
		<el-table :data="quote_order_detail_goods" height="350">
			<!-- 商品详情 -->
			<el-table-column :label="$t('message.cqorder.table6')" align="center" show-overflow-tooltip width="250">
				<template v-slot="{ row }">
					<div class="quote_order_dialog_goods">
						<!-- 图片 -->
						<router-link :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }" class="quote_order_dialog_img">
							<img :src="row.goods_images[0]" alt="">
						</router-link>
						<!-- 文字 -->
						<router-link :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }">
							<span>{{row.goods_name}}</span>
						</router-link>
					</div>
				</template>
			</el-table-column>
			<!-- 金额 -->
			<!-- <el-table-column :label="$t('message.cqorder.table7')" prop="unit_price" align="center"
				show-overflow-tooltip v-if="powerPrice">
			</el-table-column> -->
			<!-- 数量 -->
			<el-table-column :label="$t('message.cqorder.table8')" align="center" show-overflow-tooltip>
				<template v-slot="{ row }">
					{{row.goods_number}}
				</template>
			</el-table-column>
			<!-- 单位 -->
			<el-table-column :label="$t('message.cqorder.table9')" prop="unit" align="center" show-overflow-tooltip>
			</el-table-column>
			<!-- 規格 -->
			<el-table-column :label="$t('message.cqorder.table12')" align="center" v-if="powerPrice">
				<template v-slot="{row}">
					<span class="order_status_dialog_goods_price">{{row.attr_value}}</span>
				</template>
			</el-table-column>
			<!-- 备注 -->
			<!--    <el-table-column
                :label="$t('message.cqorder.table10')"
                prop="postscript"
                align="center"
                show-overflow-tooltip>
            </el-table-column> -->
		</el-table>
		<!-- 结算 -->
		<div class="quote_order_total_box">
			<!-- 数量统计 -->
			<div class="quote_order_total_num">
				<span>{{$t("message.cqorder.total1")}}</span>
				<span>{{totalMsg.totalNum}}</span>
				<span>{{$t("message.cqorder.total2")}}</span>
			</div>
			<!-- 金额统计 -->
			<!-- <div class="quote_order_total_price" v-if="powerPrice">
				<span>{{$t("message.cqorder.total3")}}</span>
				<span>{{currency}}</span>
				<span>{{totalMsg.totalPrice}}</span>
			</div> -->
			<!-- 加入按钮 -->
			<el-button type="primary" @click="handleAdd" class="quote_order_total_submit">
				<span>{{$t("message.cqorder.addCart")}}</span>
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from 'vuex'

	export default {
		data() {
			return {
				goodsr: [],
				select_status: "", // 状态修改绑定值
				examine_options: [{
						value: 0,
						label: this.$t("message.costatus.examine1")
					},
					{
						value: 1,
						label: this.$t("message.costatus.examine2")
					},
				], //审核选项
			}
		},
		computed: {
			...mapState({
				dialogVisible: state => state.dialogVisible,
				currency: state => state.currency,
				quote_examine: state => state.order.quote_examine,
				quote_order_detail: state => state.order.quote_order_detail,
				quote_order_detail_goods: state => state.order.quote_order_detail_goods,
				quote_order_detail_goodsr: state => state.order.quote_order_detail_goodsr,
				// quote_order_quote_sn: state => state.order.quote_order_quote_sn

			}),
			...mapGetters([
				'powerPrice',
			]),
			totalMsg() {
				let detail = this.quote_order_detail_goods,
					num = 0,
					price = 0;
				// let detail2 = JSON. parse(JSON. stringify(detail));
				// this.Parameters(detail2)

				for (let item of detail) {
					num += Number(item.goods_number);
					price += Number(item.goods_price);
				}
				return {
					totalNum: num,
					totalPrice: price.toFixed(2)
				}
			}
		},
		methods: {
			...mapMutations([
				"handleDialog",
				"setQuoteOrderDetail"
			]),
			...mapActions([
				"handleQuoteOrderAdd",
				"handleQuoteOrderImplement",
				"getQuoteOrderDetail"
			]),
			//去掉沒有必要的參數
			// Parameters(detail2){ 
			// 	detail2.forEach(el => {
			// 	    delete el.attr_value
			// 		delete el.goods_attr
			// 		delete el.goods_name
			// 		delete el.goods_price
			// 		delete el.num
			// 		delete el.remark
			// 		delete el.unit
			// 		delete el.unit_price

			// 	});
			// 	// console.log("查看",detail2)
			// },
			handleCloseDialog() { // 关闭模态框
				this.handleDialog(false);
				this.setQuoteOrderDetail({});
			},
			handleExamine(quote_id) { // 确认审批
				this.handleQuoteOrderImplement({
					quote_id,
					status: this.select_status
				}).then(res => {
					this.getQuoteOrderDetail(quote_id);
					let succmsg = this.$t("message.cqorder.succmsg2"),
						errmsg = this.$t("message.cqorder.errmsg2")
					this.$message({
						showClose: true,
						message: res ? succmsg : errmsg,
						type: res ? "success" : "error"
					})
				}).catch(() => {})
			},
			handleAdd() { // 加入购物车按钮
				this.handleQuoteOrderAdd(this.quote_order_detail_goodsr).then((res) => {
					if (res.type) {
						this.$message({
							showClose: true,
							message: this.$t("message.cqorder.succmsg1"),
							type: "success"
						})
						this.handleCloseDialog();
					} else {
						this.$message({
							showClose: true,
							message: this.$t('message.cart.errmsg5'),
							type: "warning"
						})
					}
				})
			}
		},
	}
</script>

<style scoped>
	/* 滚动条 */
	/deep/ .el-table__body-wrapper::-webkit-scrollbar{
		width: 5px;
		height: 10px !important;
		background-color: #ddd;

	}

	.order_status_table>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		background-color: #fd641f;
		border-radius: 5px;
	}

	.quote-order-dialog-title {
		font-size: 20px;
		font-weight: bold;
		color: #303133;
	}

	.quote-order-detail {
		margin-bottom: 5px;
	}

	.quote-order-detail-title {
		color: #909399
	}

	.quote_order_dialog_goods {
		width: 240px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	/* 商品图片 */
	.quote_order_dialog_img {
		position: relative;
		display: inline-block;
		vertical-align: middle;
		width: 50px;
		height: 50px;
		margin-right: 5px;
	}

	.quote_order_dialog_img>img {
		max-width: 100%;
		max-height: 100%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	/* 计数器 */
	.quote_order_dialog_num {
		width: 100px;
	}

	/* 合计盒子 */
	.quote_order_total_box {
		height: 50px;
		line-height: 50px;
		text-align: right;
		background-color: #EBEEF5;
	}

	.quote_order_total_num,
	.quote_order_total_price {
		display: inline-block;
		vertical-align: middle;
		margin-right: 30px;
	}

	.quote_order_total_num>span:nth-child(2),
	.quote_order_total_price>span:nth-child(2) {
		margin: 0 5px;
		color: #ff6700;
	}

	.quote_order_total_price>span:last-child {
		color: #ff6700;
		font-weight: bold;
	}

	/* 加入购物车 */
	.quote_order_total_submit {
		height: 100%;
	}
</style>
